import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { asField } from 'informed';
import { InputTypes } from './InputTypes';

const withValidatedTextInput = (WrappedComponent) => {
  const WrappedComponentWithValidatedTextInput = asField(({ fieldState, fieldApi, ...props }) => {
    const { value } = fieldState;
    const { setValue, setTouched } = fieldApi;
    const {
      className,
      onChange,
      onBlur,
      value: initialValue,
      forwardedRef,
      validate,
      validateOnBlur,
      validateOnChange,
      ...rest
    } = props;
    const inputClasses = classnames({ 'input-error': fieldState.error });

    const inputValue = value || initialValue;

    const onChangeHandler = (e) => {
      setValue(e.target.value);
      if (onChange) {
        onChange(e);
      }
    };

    const onBlurHandler = (e) => {
      setTouched(true);
      if (onBlur) {
        onBlur(e);
      }
    };
    return (
      <React.Fragment>
        <WrappedComponent
          {...rest}
          className={className}
          inputClasses={inputClasses}
          onBlur={onBlurHandler}
          onChange={onChangeHandler}
          value={inputValue}
          forwardedRef={forwardedRef}
        >
          {fieldState.error}
        </WrappedComponent>
      </React.Fragment>
    );
  });

  WrappedComponentWithValidatedTextInput.defaultProps = {
    autoComplete: 'off',
    className: '',
    label: '',
    placeholder: '',
    type: 'text',
    validateOnBlur: true,
    validateOnChange: false,
    value: undefined,
  };

  WrappedComponentWithValidatedTextInput.propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.oneOf(InputTypes),
    validateOnBlur: PropTypes.bool,
    validateOnChange: PropTypes.bool,
    value: PropTypes.string,
  };

  return WrappedComponentWithValidatedTextInput;
};

export default withValidatedTextInput;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/TextInputs/withValidatedTextInput.jsx